import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { TProCategory } from '@/interfaces/user'

export const OTHER_SERVICE_VALUE = 'OTHER' as const

type Props = {
  categories?: TProCategory[]
}

export default function ServiceSelect({ categories }: Props) {
  const { control } = useFormContext()
  return (
    <FormField
      control={control}
      name="_serviceCategoryId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>依頼するサービス</FormLabel>
          <FormDescription>
            クリエイターが用意したサービスから選択するか、「その他」で自由にご相談ください。
          </FormDescription>
          <Select onValueChange={field.onChange} value={field.value || ''}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="サービスを選択してください" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {(categories || []).map((c) => (
                <SelectItem key={c.id} value={c.id}>
                  {c.serviceTitle || c.title || '（無題のサービス）'}
                </SelectItem>
              ))}
              <SelectItem value={OTHER_SERVICE_VALUE}>その他（自由記述）</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
